interface PhaseData {
  id?: number;
  name?: string;
  hexadecimalColor?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class Phase {
  public static getNonTranslatableFields(): string[] { return ['id', 'hexadecimalColor', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name', 'hexadecimalColor', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  hexadecimalColor?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: PhaseData, translationsData: any): Phase {
    let translationData: any = {};
    for (let i = 0; i < translationsData.length; i++) {
      if (translationsData[i]['phaseId'] === data['id']) {
        translationData = translationsData[i];
        i = translationsData.length;
      }
    }
    return new Phase({
      id: data.id,
      name: translationData.name ?? data.name,
      hexadecimalColor: data.hexadecimalColor,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,
      deleteDate: data.deleteDate,
      deleterId: data.deleterId
    });
  }

  public static fromAPIList(data: PhaseData[], translationsData: any): Phase[] {
    return data.map((item: PhaseData) => Phase.fromAPI(item, translationsData));
  }

  constructor({id, name, hexadecimalColor, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : PhaseData) {
    this.id = id;
    this.name = name;
    this.hexadecimalColor = hexadecimalColor;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name,
      hexadecimalColor: this.hexadecimalColor,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
